<h1 mat-dialog-title>{{ 'language' | t }}</h1>
<div *ngFor="let x of langDatasArry" class="itemListBorder" (click)="selectionChange(x.langCode)">
  <image-loader-utils [url]="x.ISOabbr" [isFlags]="true" extraClasses="flag-rounded"></image-loader-utils>
  {{ x.langNativeNames }}
</div>

<p class="mat-caption contentPadding">
  {{ 'change_lang_warning' | t }}
</p>
